/**
 * An RFC 9562 version-7 UUID: 48-bit Unix milliseconds, then the version and
 * variant over 74 random bits, in the canonical 8-4-4-4-12 form.
 *
 * The platform mints every id as a v7 so ids sort in creation order. Browsers
 * only ship v4 (`crypto.randomUUID`), and only in secure contexts;
 * `getRandomValues` works everywhere. An id, never a secret: the first 48 bits
 * are the clock.
 */
export function uuidv7(now: number = Date.now()): string {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  const view = new DataView(bytes.buffer);
  // 48-bit big-endian milliseconds. Bitwise operators truncate to 32 bits,
  // so the clock is written as a 16-bit high half and a 32-bit low half.
  view.setUint16(0, Math.floor(now / 2 ** 32));
  view.setUint32(2, now % 2 ** 32);
  view.setUint8(6, (view.getUint8(6) & 0x0f) | 0x70); // version 7
  view.setUint8(8, (view.getUint8(8) & 0x3f) | 0x80); // variant 10
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
